import {CarrierDisplay} from '../../user-dashboard/shared/carrier-display.model';

export class LocationCarrierConfiguration {
  id?: string;
  carrierId: string;
  carrierName: string;
  vendorNumber: string;
  cmaLiteEnabled: boolean;

  static fromDto(dto: any): LocationCarrierConfiguration {
    const locationCarrierConfiguration = new LocationCarrierConfiguration();

    if (!dto) {
      return null;
    }

    locationCarrierConfiguration.id = dto.id;
    locationCarrierConfiguration.carrierId = dto.carrier_id;
    locationCarrierConfiguration.carrierName = dto.carrier_name;
    locationCarrierConfiguration.vendorNumber = dto.vendor_number;
    locationCarrierConfiguration.cmaLiteEnabled = dto.cma_lite_enabled;

    return locationCarrierConfiguration;
  }

  static fromDisplayCarrier(displayCarrier: CarrierDisplay): LocationCarrierConfiguration {
    const locationCarrierConfiguration = new LocationCarrierConfiguration();

    if (!displayCarrier) {
      return null;
    }

    locationCarrierConfiguration.id = null;
    locationCarrierConfiguration.carrierId = displayCarrier.id;
    locationCarrierConfiguration.carrierName = displayCarrier.name;
    locationCarrierConfiguration.vendorNumber = displayCarrier.vendorNumber;

    return locationCarrierConfiguration;
  }
}
